import { Link } from "react-router-dom";
import { Seo } from "../lib/seo";

const founders = [
  {
    name: "Ásgeir Örn Ásgeirsson",
    role: "Co-Founder",
    image: "/img/asgeir.jpg",
    bio: "Co-founder and board member of Meniga, where he held roles including CTO, Chief Growth Officer, and SVP of Customer Success. C.Sc. in Software Engineering, M.S. in Investment Management.",
    linkedin: "https://www.linkedin.com/in/asgeiroa/",
  },
  {
    name: "Gunnhildur Ásgeirsdóttir",
    role: "CTO & Co-Founder",
    image: "/img/gunna.jpg",
    bio: "Previously AI lead at Nova, building automation and predictive AI for customer service. Hands-on experience with modern agent frameworks and RAG, including LangGraph. B.S. in Computer Science from Reykjavík University.",
    linkedin: "https://www.linkedin.com/in/gunnhildur-%C3%A1sgeirsd%C3%B3ttir-4253252ba/",
  },
  {
    name: "Valgerður Ásgeirsdóttir",
    role: "Chief Quality Officer & Co-Founder",
    image: "/img/vala.png",
    bio: "M.Sc. candidate in Human-Centered AI at the Technical University of Denmark. Three years as a QA Engineer at Icelandair. B.S. in Software Engineering from Reykjavik University.",
    linkedin: "https://www.linkedin.com/in/valgerdur-asgeirsdottir/",
  },
  {
    name: "Tryggvi Jónsson",
    role: "Co-Founder",
    image: "/img/tryggvi.jpg",
    bio: "Two decades at the intersection of software engineering, data science, and AI. Fintech experience spans energy trading, personal finance, and regulatory reporting. Ph.D. in applied statistics and machine learning from the Technical University of Denmark.",
    linkedin: "https://www.linkedin.com/in/tryggvijonsson/",
  },
];

export const Company = () => (
  <>
    <Seo
      title="Company"
      description="Bancony is the steward of an open standard for AI in banking and the builder of bank-grade implementations on top."
      path="/company"
    />

    <section className="page-hero">
      <div className="page-hero-inner">
        <span className="section-eyebrow">Company</span>
        <h1>Steward of an open standard. Builder of bank-grade implementations.</h1>
        <p className="page-hero-sub">
          We exist for one reason: to make production AI in banking shippable in
          weeks, while the bank stays compliant, in control, and free to leave.
        </p>
      </div>
    </section>

    <section className="section">
      <div className="section-inner">
        <span className="section-eyebrow">Founders</span>
        <h2>Four founders with deep roots in fintech, AI, and banking technology.</h2>
        <div className="founders-grid" style={{ marginTop: 32 }}>
          {founders.map((f) => (
            <div className="founder-card" key={f.name}>
              <div className="founder-header">
                <div className="founder-photo-wrap">
                  <img src={f.image} alt={f.name} className="founder-photo" />
                </div>
                <div className="founder-title">
                  <h3>{f.name}</h3>
                  <span className="founder-role">{f.role}</span>
                </div>
                {f.linkedin && (
                  <a
                    className="founder-linkedin"
                    href={f.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${f.name} on LinkedIn`}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <path
                        fill="currentColor"
                        d="M20.451 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.446-2.136 2.94v5.666H9.355V9h3.414v1.561h.046c.477-.9 1.637-1.852 3.37-1.852 3.601 0 4.268 2.37 4.268 5.455v6.288zM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124zM7.119 20.452H3.554V9H7.12v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451c.978 0 1.778-.773 1.778-1.729V1.729C24 .774 23.2 0 22.222 0h.003z"
                      />
                    </svg>
                  </a>
                )}
              </div>
              <p className="founder-bio">{f.bio}</p>
            </div>
          ))}
        </div>
        <p style={{ marginTop: 28, color: "var(--ink-mute)", fontSize: 14 }}>
          Engineering, security, and sales hiring is underway. If you want in early,
          email <a href="mailto:hello@bancony.com">hello@bancony.com</a>.
        </p>
      </div>
    </section>

    <section className="section soft">
      <div className="section-inner">
        <div className="regulation-split">
          <div>
            <span className="section-eyebrow">Investors & advisors</span>
            <h2 style={{ fontSize: 24 }}>Coming soon.</h2>
            <p style={{ color: "var(--ink-soft)", fontSize: 15 }}>
              Investor and advisor announcements will be made once permissions are in
              hand. Get in touch if you'd like to talk to us about partnership.
            </p>
          </div>
          <div>
            <span className="section-eyebrow">Locations</span>
            <h2 style={{ fontSize: 24 }}>Headquartered in Reykjavík, working globally.</h2>
            <p style={{ color: "var(--ink-soft)", fontSize: 15 }}>
              We work with banks wherever they are. Additional locations will follow the
              first wave of implementations.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="section-inner">
        <div className="final-cta">
          <div>
            <h2>Talk to us.</h2>
            <p>For sales: <a style={{ color: "#fff" }} href="mailto:hello@bancony.com">hello@bancony.com</a> · For press: <a style={{ color: "#fff" }} href="mailto:press@bancony.com">press@bancony.com</a></p>
          </div>
          <div className="final-cta-cta">
            <Link to="/contact" className="btn btn-primary">Contact us</Link>
          </div>
        </div>
      </div>
    </section>
  </>
);
